import { useGetCurrentUserQuery } from '@sellsen/services';
import { useMemo } from 'react';

/**
 * Oturumdaki kullanıcının rol adları. `isLoading` dışarı verilir: yükleme sırasında roller boş
 * göründüğü için tüketen yer "yetkisiz" kararı vermeden önce beklemelidir.
 */
export const useCurrentRoles = () => {
  const { data: currentUser, isLoading } = useGetCurrentUserQuery();
  const roles = useMemo(
    () =>
      new Set(
        Array.from(currentUser?.roles ?? [])
          .map((role) => role.name)
          .filter((name): name is string => Boolean(name))
      ),
    [currentUser?.roles]
  );
  return { roles, isLoading };
};
